export const TreeMode = Object.freeze({
  CATEGORY: 'categories',
  DIRECTORY: 'directories',
});

export const BrowserMode = Object.freeze({
  DOC: 'doc',
  MAM: 'mam',
});

export const FilterMode = Object.freeze({
  BASIC: 'basic',
  ADVANCED: 'advanced',
});

export const FinishController = Object.freeze({
  [BrowserMode.DOC]: '/document/browser',
  [BrowserMode.MAM]: '/document/media',
});
